/*
 * @Author: 右侧内容重构
 * @Date:   2017-09-11 16:07:27
 * @Last Modified by:   Marte
 * @Last Modified time: 2017-10-24 11:10:11
 */

'use strict';
angular.module('digitalDetailModule', [])
    .directive('digitalDetail', ["$state", "$location", "$timeout", '$stateParams', '$sce', 'resCtrModalService', 'trsspliceString', 'trsHttpService', 'ueditorService', 'resourceCenterService', 'modalDialog', 'storageListenerService',
        function($state, $location, $timeout, $stateParams, $sce, resCtrModalService, trsspliceString, trsHttpService, ueditorService, resourceCenterService, modalDialog, storageListenerService) {
            // Runs during compile
            return {
                scope: {
                    rebuildData: '='
                },
                restrict: 'AE',
                templateUrl: './networkResource/classifiedResource/digitalnews/quickPreview/detail/detail_tpl.html',
                replace: true,
                link: function(scope, iElm, iAttrs, controller) {
                    initStatus();
                    initData();
                    /**
                     * [initStatus description]初始化状态
                     * @return {[type]} [description]
                     */
                    function initStatus() {
                        scope.status = {
                            currModule: "szb",
                        };
                        scope.detailData = {};
                        scope.params = {
                            "serviceid": scope.status.currModule,
                            "modelid": "detailData",
                            "channelName": scope.status.currModule,
                            "typeid": "zyzx",
                        };
                    }

                    /**
                     * [initData description]初始化数据
                     * @return {[type]} [description]
                     */
                    function initData() {
                        if (angular.isDefined(scope.rebuildData)) {
                            scope.params.guid = scope.rebuildData.guid;
                            requestData();
                        }
                    }
                    /**
                     * [requestData description]获取数据
                     * @return {[type]} [description]
                     */
                    function requestData() {
                        scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), scope.params, "post").then(function(data) {
                            if (data && data.content) {
                                scope.detailIndexname = data.summary_info.indexName;
                                scope.detailData = data.content[0];
                                scope.detailData.CONTENT = ueditorService.replaceHtmlBlank(scope.detailData.CONTENT); //将html正文中的半角空格换成全角空格
                                scope.detailData.CONTENT = scope.detailData.CONTENT.replace(/(<(?:p|div)[^>]*>(?:<(?:span|b)[^>]*>)*)(?:&nbsp;| |　)*/ig, "$1　　").replace(/(<br[^>]*>)(?:&nbsp;| |　)*/ig, "$1　　").replace(/>　　</g, "\>\<").replace(/text-indent:[^>]*em/g, "text-indent:0em");
                                scope.detailData.CONTENT = data.content[0] && $sce.trustAsHtml(scope.detailData.CONTENT);
                                scope.detailData.keywordsArr = scope.detailData.KEYWORDS === "" ? [] : scope.detailData.KEYWORDS.split(";");
                            }
                        });
                    }
                    /**
                     * [openOriginalPic description] 查看完整图片
                     * @param  {[type]} url [description] 图片地址
                     * @return {[type]}     [description]
                     */
                    scope.openOriginalPic = function(url) {
                        window.open(url);
                    };
                    /**
                     * [openTakeDraftModal description] 取稿
                     * @return {[type]} [description]
                     */
                    scope.openTakeDraftModal = function() {
                        var params = {
                            serviceid: "mlf_bigdataexchange",
                            methodname: "fetch",
                            guid: scope.rebuildData.guid,
                            indexname: scope.detailIndexname,
                            channelName: scope.status.currModule,
                        };
                        var modalInstance = resCtrModalService.fullTakeDraft(params, true, [scope.rebuildData]);
                        modalInstance.result.then(function(data) {
                            takeDraftDownloadImgs(data).then(function() {
                                storageListenerService.addListenerToResource("takeDraft");
                            });
                        }, function() {
                            storageListenerService.addListenerToResource("takeDraft");
                        });
                    };
                    /**
                     * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
                     * @param  {[type]} data [description]
                     * @return {[type]}      [description]
                     */
                    function takeDraftDownloadImgs(data) {
                        var deferred = $q.defer();
                        var needDownloadImg = false;
                        for (var i = 0; i < data.REPORTS.length; i++) {
                            if (data.REPORTS[i].PICERROR == 1) {
                                needDownloadImg = true;
                                break;
                            }
                        }
                        if (needDownloadImg) {
                            resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                                deferred.resolve();
                            });
                        } else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }
                    //个人素材(稿件批量添加到个人素材)
                    scope.CreationAxis = function() {
                        var params = {
                            typeid: "zyzx",
                            serviceid: "mlf_bigdataexchange",
                            methodname: "batchPersonalMaterial",
                            channelName: scope.status.currModule, //栏目名称全拼结构
                            PersonalMaterialId: 0, //所属文件夹ID，默认根节点（0）
                            indexName: scope.detailIndexname,
                            guid: scope.rebuildData.guid,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            modalDialog.alertType("添加成功", "", "success", false, function() {

                            });
                        });
                    };
                    /** 收藏*/
                    scope.collect = function() {
                        var params = {
                            serviceid: "mlf_bigdataexchange",
                            methodname: "collect",
                            guid: scope.rebuildData.guid,
                            indexname: scope.detailIndexname,
                            channelName: scope.status.currModule,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                            modalDialog.alertType("收藏成功!", "", "success", false, "");
                        });
                    };
                    /**
                     * [openTarget description]查看详情
                     * @return {[type]} [description]
                     */
                    scope.openTarget = function() {
                        var url = $state.href("resourcedetail", {
                            guid: scope.rebuildData.guid,
                            channel: 'szb',
                            indexname: scope.detailIndexname
                        });
                        window.open(url);
                    };
                    /**
                     * [plainView description] 普通视图
                     * @return {[type]} [description]
                     */
                    scope.plainView = function() {
                        $state.go("front.networksource.classifiedresource.digital.resource", $stateParams);
                    };
                }
            };
        }
    ]);
